import styled from "styled-components";
import { spacing } from "../../styling.constants";

export const Hr = styled.hr`
  margin: ${spacing.xl} 0;
  border: 1px solid #d8dae5;
`;
